import useEntity from './useEntity'

const useWorkflow = ({ caseId, personId }) => {
  return useEntity('workflows', caseId, { personId }, 'caseId')
}

export default useWorkflow
